import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "label", "enableFilters"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { styled } from '@linaria/react';
/**
 * Icon Template
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const IconTemplate = (name, svg) => "\nimport {IconProps, AbstractIcon} from './AbstractIcon'\n\nexport const ICON_NAME = (props:IconProps) => {\n\treturn (\n\t\t<AbstractIcon {...props}>\n\t\t\t".concat(svg, "\n\t\t</AbstractIcon>\n\t)\n}\n");
export const StyledIcon = /*#__PURE__*/styled("svg")({
  name: "StyledIcon",
  class: "s11apfzl",
  vars: {
    "s11apfzl-0": [props => props.size || props.width || '3rem'],
    "s11apfzl-2": [props => props.size || props.height || '3rem'],
    "s11apfzl-3": [props => props.rotate ? "rotate(".concat(props.rotate, ")") : 'none'],
    "s11apfzl-4": [props => props.color || 'var(--clr-icon, #1a1a1a)'],
    "s11apfzl-5": [props => props.colorAlt || 'var(--clr-icon-alt, #f4f5f4)'],
    "s11apfzl-7": [props => props.strokeWidth || '1.6'],
    "s11apfzl-8": [({
      hasShadow = false,
      hasGlow = false
    }) => hasShadow || hasGlow ? "".concat(hasShadow ? 'url(#shadow)' : '', " ").concat(hasGlow ? 'url(#glow)' : '') : 'none']
  }
});
export const AbstractIcon = _ref => {
  let {
    children,
    label = '',
    enableFilters = true
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledIcon, _objectSpread(_objectSpread({
      fill: "transparent"
    }, props), {}, {
      viewBox: props.viewBox || '0 0 24 24',
      ariaHidden: props.ariaHidden === false ? false : true,
      focusable: props.focusable || false,
      xmlns: "http://www.w3.org/2000/svg",
      className: props.className || '',
      children: [children, enableFilters == true ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("filter", {
          id: "shadow",
          colorInterpolationFilters: "linearRGB",
          children: /*#__PURE__*/_jsx("feDropShadow", {
            dx: "0",
            dy: "0",
            stdDeviation: "2",
            floodColor: props.shadowColor || 'var(--clr-bg, #202224)',
            floodOpacity: "1"
          })
        }), /*#__PURE__*/_jsxs("filter", {
          id: "glow",
          height: "300%",
          width: "300%",
          x: "-75%",
          y: "-75%",
          colorInterpolationFilters: "linearRGB",
          children: [/*#__PURE__*/_jsx("feMorphology", {
            id: "glowRadius",
            operator: "dilate",
            radius: "1",
            in: "SourceAlpha",
            result: "thicken"
          }), /*#__PURE__*/_jsx("feGaussianBlur", {
            in: "thicken",
            stdDeviation: "1",
            result: "blurred"
          }), /*#__PURE__*/_jsx("feFlood", {
            floodColor: props.glowColor || 'var(--clr-blue)',
            result: "glowColor"
          }), /*#__PURE__*/_jsx("feComposite", {
            in: "glowColor",
            in2: "blurred",
            operator: "in",
            result: "softGlow_colored"
          }), /*#__PURE__*/_jsx("feMorphology", {
            operator: "dilate",
            radius: "2",
            in: "SourceAlpha",
            result: "thicken2"
          }), /*#__PURE__*/_jsx("feGaussianBlur", {
            in: "thicken2",
            stdDeviation: "3",
            result: "blurred2"
          }), /*#__PURE__*/_jsx("feFlood", {
            floodColor: props.glowColor2 || '#5ed4ff',
            result: "glowColor2"
          }), /*#__PURE__*/_jsx("feComposite", {
            in: "glowColor2",
            in2: "blurred2",
            operator: "in",
            result: "softGlow_colored2"
          }), /*#__PURE__*/_jsxs("feMerge", {
            children: [/*#__PURE__*/_jsx("feMergeNode", {
              in: "softGlow_colored"
            }), /*#__PURE__*/_jsx("feMergeNode", {
              in: "softGlow_colored2"
            }), /*#__PURE__*/_jsx("feMergeNode", {
              in: "SourceGraphic"
            })]
          })]
        }), /*#__PURE__*/_jsxs("filter", {
          id: "glowXL",
          height: "300%",
          width: "300%",
          x: "-75%",
          y: "-75%",
          colorInterpolationFilters: "linearRGB",
          children: [/*#__PURE__*/_jsx("feMorphology", {
            id: "glowRadius",
            operator: "dilate",
            radius: "4",
            in: "SourceAlpha",
            result: "thicken"
          }), /*#__PURE__*/_jsx("feGaussianBlur", {
            in: "thicken",
            stdDeviation: "5",
            result: "blurredXL"
          }), /*#__PURE__*/_jsx("feFlood", {
            floodColor: props.glowColor || 'var(--clr-blue)',
            result: "glowColorXL"
          }), /*#__PURE__*/_jsx("feComposite", {
            in: "glowColorXL",
            in2: "blurredXL",
            operator: "in",
            result: "softGlowXL_colored"
          }), /*#__PURE__*/_jsx("feMorphology", {
            operator: "dilate",
            radius: "2",
            in: "SourceAlpha",
            result: "thickenXL2"
          }), /*#__PURE__*/_jsx("feGaussianBlur", {
            in: "thickenXL2",
            stdDeviation: "3",
            result: "blurredXL2"
          }), /*#__PURE__*/_jsx("feFlood", {
            floodColor: props.glowColor2 || '#5ed4ff',
            result: "glowColorXL2"
          }), /*#__PURE__*/_jsx("feComposite", {
            in: "glowColorXL2",
            in2: "blurredXL2",
            operator: "in",
            result: "softGlowXL_colored2"
          }), /*#__PURE__*/_jsxs("feMerge", {
            children: [/*#__PURE__*/_jsx("feMergeNode", {
              in: "softGlowXL_colored"
            }), /*#__PURE__*/_jsx("feMergeNode", {
              in: "softGlowXL_colored2"
            }), /*#__PURE__*/_jsx("feMergeNode", {
              in: "SourceGraphic"
            })]
          })]
        })]
      }) : null]
    })), /*#__PURE__*/_jsx("span", {
      className: "visually-hidden",
      children: label
    })]
  });
};

require("./AbstractIcon.linaria.module.css!=!../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./AbstractIcon.tsx");